// components/StripeOnboarding.jsx
import React, { useState } from 'react';
import { Card, Select, Button, Alert, Typography, Space, message } from 'antd';
import { BankOutlined } from '@ant-design/icons';
import { createAccount } from '../../services/stripeService';

const { Title, Text, Paragraph } = Typography;
const { Option } = Select;

function StripeOnboarding({ userType, userId, email }) {
  const [country, setCountry] = useState('US');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleOnboarding = async () => {
    setLoading(true);
    setError(null);

    try {
      const { data, error: apiError } = await createAccount(userType, userId, email, country);

      if (apiError) {
        throw new Error(apiError);
      }

      // Redirect to Stripe's hosted onboarding flow
      if (data.onboardingUrl) {
        message.success('Redirecting to Stripe...');
        window.location.href = data.onboardingUrl;
      } else {
        throw new Error('No onboarding URL returned');
      }
    } catch (err) {
      setError(err.message || 'Something went wrong');
      message.error('Failed to connect with Stripe');
    } finally {
      setLoading(false);
    }
  };

  const getDescriptionText = () => {
    return userType === 'investor'
      ? "You'll need to connect a Stripe account to invest in projects."
      : "You'll need to connect a Stripe account to receive funds for your projects.";
  };

  return (
    <Card style={{ maxWidth: 500, margin: '0 auto' }}>
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <BankOutlined style={{ fontSize: 24, marginRight: 12 }} />
          <Title level={4} style={{ margin: 0 }}>
            Connect Your Stripe Account
          </Title>
        </div>

        <div>
          <Text strong>Country</Text>
          <Select style={{ width: '100%', marginTop: 8 }} value={country} onChange={setCountry} disabled={loading}>
            <Option value="US">United States</Option>
            <Option value="GB">United Kingdom</Option>
            <Option value="CA">Canada</Option>
            <Option value="KE">Kenya</Option>
            <Option value="AU">Australia</Option>
            <Option value="DE">Germany</Option>
            <Option value="FR">France</Option>
          </Select>
        </div>

        {error && <Alert message={error} type="error" showIcon />}

        <Button type="primary" onClick={handleOnboarding} loading={loading} block>
          Connect with Stripe
        </Button>

        <Paragraph type="secondary">{getDescriptionText()}</Paragraph>
      </Space>
    </Card>
  );
}

export default StripeOnboarding;
